var map = {
	"./jh.png": "khbN",
	"./jhHover.png": "XlW8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BQ8A";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/funImg ^\.\/jh.*\.png$
// module id = BQ8A
// module chunks = 1